/**
 * Search overlay (Includes/SearchOverlay.ss): the magnifier in the header opens it, the form
 * loads the results from /suche/results and then the generated answer from /suche/answer.
 * Without JavaScript the magnifier and the form lead to the search page /suche/.
 */
export function initSearch() {
    initOverlay();
    // Search page /suche/?q=… rendered by the server
    loadAnswer(document.querySelector('.search [data-search-answer]'));
}

function initOverlay() {
    const dialog = document.getElementById('search-overlay');
    const opener = document.querySelector('[data-search-open]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') {
        return;
    }

    const form = dialog.querySelector('.search_bar');
    const input = form.querySelector('input[name="q"]');
    const panel = dialog.querySelector('[data-search-panel]');
    let request = null;

    opener.addEventListener('click', (event) => {
        event.preventDefault();
        dialog.showModal();
        input.focus();
        input.select();
    });

    dialog.querySelector('[data-search-close]').addEventListener('click', () => dialog.close());

    // A click on the backdrop (outside the bar and the panel) closes the overlay
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
            dialog.close();
        }
    });

    dialog.addEventListener('close', () => opener.focus());

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        const query = input.value.trim();
        if (!query) {
            return;
        }

        request?.abort();
        request = new AbortController();
        const url = form.dataset.searchResults + '?' + new URLSearchParams(new FormData(form));

        panel.hidden = false;
        panel.setAttribute('aria-busy', 'true');
        panel.classList.add('search_panel--loading');

        fetch(url, {signal: request.signal})
            .then((response) => response.ok ? response.text() : Promise.reject(response.status))
            .then((html) => {
                // Rendered and escaped by the server (Includes/SearchResults.ss)
                panel.innerHTML = html;
                loadAnswer(panel.querySelector('[data-search-answer]'), request.signal);
            })
            .catch((error) => {
                if (error?.name !== 'AbortError') {
                    panel.innerHTML = '';
                    panel.hidden = true;
                    form.submit();
                }
            })
            .finally(() => {
                panel.setAttribute('aria-busy', 'false');
                panel.classList.remove('search_panel--loading');
            });
    });
}

/**
 * Load the generated answer into its box; the box stays hidden if loading fails.
 */
function loadAnswer(box, signal) {
    if (!box) {
        return;
    }

    const text = box.querySelector('.search_answer_text');
    box.hidden = false;

    fetch(box.dataset.searchAnswer, {headers: {Accept: 'application/json'}, signal})
        .then((response) => response.ok ? response.json() : Promise.reject(response.status))
        .then((data) => {
            if (!data.html) {
                box.hidden = true;
                return;
            }
            // The HTML is built and escaped on the server (SearchService::formatAnswer)
            text.innerHTML = data.html;
        })
        .catch(() => {
            box.hidden = true;
        })
        .finally(() => {
            box.setAttribute('aria-busy', 'false');
        });
}
